import { render } from "./costAlerts.vue?vue&type=template&id=38bbc010&scoped=true"
import script from "./costAlerts.vue?vue&type=script&lang=js"
export * from "./costAlerts.vue?vue&type=script&lang=js"

import "./costAlerts.vue?vue&type=style&index=0&id=38bbc010&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38bbc010"]])

export default __exports__